import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { graphql } from 'gatsby';

import ProjectCard from '../components/projectCard';
import colors from '../utils/colors';

const ProjectsBody = styled.div`
  span.emphasis {
    color: #2f3b54;
    transition: all 0.5s;
  }
  margin-bottom: 40px;
  border-radius: 0px;
  transition-delay: 0ms;
  visibility: visible;
  opacity: 1;
  transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); 
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1) 0s, opacity 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) 0.3s, transform 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) 0.3s;
  color: #2f3b54;
`;

const ProjectCardWrapper = styled.div`
  display: flex;
  min-width: 0;
`;

const ProjectCards = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  color: #2f3b54;

  @media only screen and (max-width: 60em) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media only screen and (max-width: 40em) {
    grid-template-columns: 1fr;
  }
`;

class ProjectsPage extends React.Component {
  componentDidMount() {
    this.node.style.opacity = 0;
    window.requestAnimationFrame(() => {
      this.node.style.transition = 'opacity 1000ms ease-out';
      this.node.style.opacity = 1;
    });
  }

  render() {
    const projectCards = [];

    const ordered = [...this.props.data.allProjectsJson.edges]
      .sort((a, b) => (a.node.order || 99) - (b.node.order || 99));

    ordered.forEach((project) => {
      projectCards.push(
        <ProjectCardWrapper key={project.node.title}>
          <ProjectCard
            title={project.node.title}
            description={project.node.description}
            src={project.node.src}
            url={project.node.url}
            video={project.node.video}
            tags={project.node.tags}
          />
        </ProjectCardWrapper>,
      );
    });

    return (
      <ProjectsBody
        ref={(node) => {
          this.node = node;
        }}
      >
        <Helmet>
          <title>Projects - Kartikeya Sharma</title>
        </Helmet>
        <ProjectCards>{projectCards}</ProjectCards>
      </ProjectsBody>
    );
  }
}

ProjectsPage.propTypes = {
  data: PropTypes.shape({
    allProjectsJson: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            url: PropTypes.string,
            description: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            src: PropTypes.string,
          }).isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

export default ProjectsPage;
export const pageQuery = graphql`
  {
    allProjectsJson {
      edges {
        node {
          url
          description
          title
          src
          video
          tags
          order
        }
      }
    }
  }
`;
